module.exports = __webpack_public_path__ + "static/img/yun01_7.fcf17d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/yun01_7.jpg
// module id = Z/Um
// module chunks = 1